module.exports = __webpack_public_path__ + "img/solid-pod-access-oracle.d2ac3402.png";